import { Chip } from '@mui/material';
import { TranslationStatus } from '../helpers/types';

const STATUS_META: Record<
  TranslationStatus,
  { label: string; color: 'default' | 'info' | 'warning' | 'success' | 'error' }
> = {
  [TranslationStatus.PENDING]: { label: 'Pending', color: 'default' },
  [TranslationStatus.MACHINE_TRANSLATED]: {
    label: 'AI Draft',
    color: 'info',
  },
  [TranslationStatus.IN_REVIEW]: { label: 'In Review', color: 'warning' },
  [TranslationStatus.APPROVED]: { label: 'Approved', color: 'success' },
  [TranslationStatus.REJECTED]: { label: 'Rejected', color: 'error' },
};

interface StatusChipProps {
  status?: TranslationStatus;
}

export default function StatusChip({ status }: StatusChipProps) {
  const meta = status
    ? STATUS_META[status]
    : { label: 'Untranslated', color: 'default' as const };
  return <Chip size="small" label={meta.label} color={meta.color} />;
}
